//Subscription related
export const SUBSCRIPTION_DAYS_BEFORE_ALERT=7